export interface VehicleDetailsResponse {
  make: string;
  model: string;
  year: number;
  registrationDate: string;
  derivative: string;
  colour: string;
  owners: number;
  checks: VehicleChecks;
}

export type SaleMethod = "retail" | "trade";

export enum ConditionGrades {
  Excellent = "excellent",
  Good = "good",
  Average = "average",
  BelowAverage = "belowAverage",
  Poor = "poor",
}

export enum ServiceHistory {
  FullMainDealer = "full",
  FullIndependentGarage = "fullIndependent",
  Partial = "some",
  None = "none",
  NotDue = "notDue",
}

export interface ValuationResponse {
  costs: number;
  depreciation: number;
  forecastedExitSalePrice: number;
  id: string;
  margin: number;
  saleMethod: SaleMethod;
  targetRetailPrice: number;
  valuationGbp: number;
}

export interface ValuationPayload {
  vrm: string;
  mileage: number;
  condition: ConditionGrades;
  serviceHistory: string;
  user: string;
}

export interface PxQualifications {
  service_history?: string;
  date_of_last_service?: string;
  import?: boolean;
  key?: number;
  known_faults?: string;
  left_handed?: number;
  log_book?: number;
  mileage_incorrect?: boolean;
  plate_transfer_pending?: number;
  speedo_change?: number;
  total_loss?: boolean;
  was_taxi?: number;
}

export interface EscalateValuationPayload {
  condition?: ConditionGrades;
  costs?: number;
  depreciation?: number;
  details?: string;
  emailAddress: string;
  forecastedExitSalePrice?: number;
  margin?: number;
  pxQualifications: PxQualifications;
  qualificationId: number;
  reason: string;
  saleMethod?: SaleMethod;
  targetRetailPrice?: string;
  valuation?: number;
  valuationUuid?: string;
  vrm: string;
}

export interface SubmitValuationPayload {
  condition: ConditionGrades;
  costs: number;
  depreciation: number;
  emailAddress: string;
  forecastedExitSalePrice: number;
  margin: number;
  pxQualifications: PxQualifications;
  qualificationId: number;
  saleMethod: SaleMethod;
  targetRetailPrice: string;
  valuation: number;
  valuationUuid: string;
  vrm: string;
}

export type FailedCheckDetails = {
  key: string;
  value: string;
};

export type VehicleChecks = {
  passed: boolean;
  checks: FailedCheckDetails[];
};

export type JwtTokenPayload = {
  iss: string; // e.g. "https://www.carsanet.co.uk/"
  aud: string; // e.g.  "all-audiences"
  jti: string;
  iat: number; // e.g. 1725265949
  exp: number; // e.g. 1725301949
  scp: string; // e.g. "valuations"
  kid: string; // e.g. "main-key"
  unm: string; // e.g. "Joe Bloggs"
  uem: string; // e.g. "joe@domain.com"
};

export type CarsanetValuationsResponse = {
  urlToRedirect: string;
};

export enum FailedCheckKeys {
  BLACKLIST_MAKE = "BLACKLIST_MAKE",
  COLOUR_CHANGE = "COLOUR_CHANGE",
  COLOUR_PROBLEMS = "COLOUR_PROBLEMS",
  COMMERCIAL_VEHICLE = "COMMERCIAL_VEHICLE",
  EXPORTED = "EXPORTED",
  HIGH_PERFORMANCE_BRAND = "HIGH_PERFORMANCE_BRAND",
  HIGH_PERFORMANCE_MODEL = "HIGH_PERFORMANCE_MODEL",
  HIGH_PERFORMANCE_TRIM = "HIGH_PERFORMANCE_TRIM",
  HIGH_RISK = "HIGH_RISK",
  IMPORTED = "IMPORTED",
  INSURANCE_WRITE_OFF = "INSURANCE_WRITE_OFF",
  KEEPER_CHANGED = "KEEPER_CHANGED",
  MANUFACTURE_AND_REGISTRATION_DISCREPANCY = "MANUFACTURE_AND_REGISTRATION_DISCREPANCY",
  MECHANICAL_PROBLEMS = "MECHANICAL_PROBLEMS",
  MILEAGE_DISCREPANCY = "MILEAGE_DISCREPANCY",
  MOT_MILEAGE_DISCREPANCY = "MOT_MILEAGE_DISCREPANCY",
  POSSIBLE_TAXI = "POSSIBLE_TAXI",
  SCRAPPED = "SCRAPPED",
  STOLEN = "STOLEN",
  TRADE_FINANCE = "TRADE_FINANCE",
}
